// ✅ CONFIGURAÇÃO DE AMBIENTE

// ✅ FUNÇÃO DE VALIDAÇÃO DE VARIÁVEIS OBRIGATÓRIAS
function validarVariavelObrigatoria(nome, valor) {
  if (!valor) {
    const erro = `❌ ERRO CRÍTICO: Variável de ambiente obrigatória não definida: ${nome}`;
    console.error(erro);
    throw new Error(erro);
  }
  return valor;
}

// ✅ VALIDAÇÃO DAS VARIÁVEIS CRÍTICAS
// NODE_ENV pode ser 'development', 'homolog' ou 'production'
// Se não estiver definido, usa 'development' como padrão
// O react-scripts sempre usa NODE_ENV=development ao rodar `npm start`.
// REACT_APP_NODE_ENV permite testar localmente o perfil de produção sem
// confundir o modo de compilação com o ambiente da aplicação.
const NODE_ENV = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || 'development';

// Validar se NODE_ENV tem um valor válido
if (!['development', 'homolog', 'production'].includes(NODE_ENV)) {
  console.warn(`⚠️ NODE_ENV inválido: ${NODE_ENV}. Usando 'development' como padrão.`);
  // Não quebra a aplicação, apenas avisa
}

const env = {
  // ============================================================================
  // CONFIGURAÇÕES DO FRONTEND
  // ============================================================================
  SERVER_HOST: validarVariavelObrigatoria('REACT_APP_SERVER_HOST', process.env.REACT_APP_SERVER_HOST),
  PORTA_FRONTEND: validarVariavelObrigatoria('REACT_APP_PORTA_FRONTEND', process.env.REACT_APP_PORTA_FRONTEND),

  // ============================================================================
  // CONFIGURAÇÕES DO BACKEND (ESPECÍFICAS POR AMBIENTE)
  // ============================================================================
  get SERVER_BACKEND() {
    if (NODE_ENV === 'development') {
      return validarVariavelObrigatoria('REACT_APP_SERVER_BACKEND_DEV', process.env.REACT_APP_SERVER_BACKEND_DEV);
    } else if (NODE_ENV === 'homolog') {
      return validarVariavelObrigatoria('REACT_APP_SERVER_BACKEND_HMG', process.env.REACT_APP_SERVER_BACKEND_HMG);
    } else {
      return validarVariavelObrigatoria('REACT_APP_SERVER_BACKEND_PROD', process.env.REACT_APP_SERVER_BACKEND_PROD);
    }
  },
  
  get PORTA_BACKEND() {
    if (NODE_ENV === 'development') {
      return validarVariavelObrigatoria('REACT_APP_PORTA_BACKEND_DEV', process.env.REACT_APP_PORTA_BACKEND_DEV);
    } else if (NODE_ENV === 'homolog') {
      return validarVariavelObrigatoria('REACT_APP_PORTA_BACKEND_HMG', process.env.REACT_APP_PORTA_BACKEND_HMG);
    } else {
      return validarVariavelObrigatoria('REACT_APP_PORTA_BACKEND_PROD', process.env.REACT_APP_PORTA_BACKEND_PROD);
    }
  },

  // ============================================================================
  // CONFIGURAÇÕES DE AUTENTICAÇÃO
  // ============================================================================
  SECOND_SECRET_KEY: validarVariavelObrigatoria('REACT_APP_SECOND_SECRET_KEY', process.env.REACT_APP_SECOND_SECRET_KEY),
  LGPD_KEY: validarVariavelObrigatoria('REACT_APP_LGPD_KEY', process.env.REACT_APP_LGPD_KEY),
  ENCRYPTION_KEY: validarVariavelObrigatoria('REACT_APP_ENCRYPTION_KEY', process.env.REACT_APP_ENCRYPTION_KEY),

  // ============================================================================
  // CONFIGURAÇÕES DE TIMEOUT
  // ============================================================================
  API_TIMEOUT: validarVariavelObrigatoria('REACT_APP_API_TIMEOUT', process.env.REACT_APP_API_TIMEOUT),
  DEFAULT_TIMEOUT: validarVariavelObrigatoria('REACT_APP_DEFAULT_TIMEOUT', process.env.REACT_APP_DEFAULT_TIMEOUT),

  // ============================================================================
  // CONFIGURAÇÕES DE FUSO HORÁRIO (ESPECÍFICAS POR AMBIENTE)
  // ============================================================================
  get UTC_OFFSET() {
    if (NODE_ENV === 'development') {
      return validarVariavelObrigatoria('REACT_APP_UTC_OFFSET_DEV', process.env.REACT_APP_UTC_OFFSET_DEV);
    } else if (NODE_ENV === 'homolog') {
      return validarVariavelObrigatoria('REACT_APP_UTC_OFFSET_HMG', process.env.REACT_APP_UTC_OFFSET_HMG);
    } else {
      return validarVariavelObrigatoria('REACT_APP_UTC_OFFSET_PROD', process.env.REACT_APP_UTC_OFFSET_PROD);
    }
  },

  // ============================================================================
  // CONFIGURAÇÕES DE AMBIENTE
  // ============================================================================
  NODE_ENV: NODE_ENV,
  // IS_DEVELOPMENT é baseado em NODE_ENV ou pode ser sobrescrito por variável de ambiente
  IS_DEVELOPMENT: process.env.REACT_APP_IS_DEVELOPMENT === 'true' || NODE_ENV === 'development',
  // APP_ENV pode ser derivado de NODE_ENV se não estiver definido
  APP_ENV: process.env.REACT_APP_APP_ENV || (NODE_ENV === 'development' ? 'dev' : NODE_ENV === 'homolog' ? 'homolog' : 'prod'),

  // ============================================================================
  // CONFIGURAÇÕES DE API
  // ============================================================================
  // Base URL para requisições
  API_BASE_URL: '/api',
  
  // ✅ API_URL para compatibilidade (usar getApiUrl() em vez disso)
  API_URL: '/api',
  
  // URLs públicas por ambiente (apenas para montar links)
  getPublicURL: () => {
    if (NODE_ENV === 'development') {
      return validarVariavelObrigatoria('REACT_APP_PUBLIC_URL_DEV', process.env.REACT_APP_PUBLIC_URL_DEV);
    } else if (NODE_ENV === 'homolog') {
      return validarVariavelObrigatoria('REACT_APP_PUBLIC_URL_HMG', process.env.REACT_APP_PUBLIC_URL_HMG);
    } else {
      return validarVariavelObrigatoria('REACT_APP_PUBLIC_URL_PROD', process.env.REACT_APP_PUBLIC_URL_PROD);
    }
  },

  // ✅ CONFIGURAÇÃO DE API
  getApiUrl: () => {
    return '/api';
  },

  // ✅ URL COMPLETA PARA LOGIN DIRETO (FALLBACK)
  getDirectApiUrl: () => {
    if (NODE_ENV === 'development') {
      return validarVariavelObrigatoria('REACT_APP_API_URL_DEV', process.env.REACT_APP_API_URL_DEV);
    } else if (NODE_ENV === 'homolog') {
      return validarVariavelObrigatoria('REACT_APP_API_URL_HMG', process.env.REACT_APP_API_URL_HMG);
    } else {
      return validarVariavelObrigatoria('REACT_APP_API_URL_PROD', process.env.REACT_APP_API_URL_PROD);
    }
  },

  // ============================================================================
  // CONFIGURAÇÕES DE NOTIFICAÇÃO
  // ============================================================================
  NOTIFICATION_DURATION: validarVariavelObrigatoria('REACT_APP_NOTIFICATION_DURATION', process.env.REACT_APP_NOTIFICATION_DURATION)
};

export default env;
